import { computed, nextTick, onBeforeUnmount, onMounted, ref, watch } from 'vue'

export default {
    name: 'FormConfirmSubmitDialog',
    props: {
        dialogState: {
            type: Object,
            required: true,
        },
    },
    setup(props) {
        const confirmButtonRef = ref(null)
        const cancelButtonRef = ref(null)
        const previouslyFocused = ref(null)

        const isOpen = computed(() => !!props.dialogState.open)
        const title = computed(() => props.dialogState.title)
        const text = computed(() => props.dialogState.text)
        const confirmLabel = computed(() => props.dialogState.confirmLabel)
        const cancelLabel = computed(() => props.dialogState.cancelLabel)

        const TITLE_ID = 'kb-form-confirm-submit-dialog-title'
        const DESCRIPTION_ID = 'kb-form-confirm-submit-dialog-description'

        const close = () => props.dialogState.onCancel?.()
        const confirm = () => props.dialogState.onConfirm?.()

        const onBackdropClick = (event) => {
            if (event.target === event.currentTarget) close()
        }

        const tabTrap = (event) => {
            if (event.key !== 'Tab') return
            const first = confirmButtonRef.value
            const last = cancelButtonRef.value
            if (!first || !last) return

            if (event.shiftKey && document.activeElement === first) {
                event.preventDefault()
                last.focus()
            } else if (!event.shiftKey && document.activeElement === last) {
                event.preventDefault()
                first.focus()
            }
        }

        const onKeydown = (event) => {
            if (!isOpen.value || event.key !== 'Escape') return
            event.preventDefault()
            event.stopPropagation()
            close()
        }

        watch(isOpen, async (open) => {
            if (open) {
                previouslyFocused.value = document.activeElement
                document.addEventListener('keydown', onKeydown, true)
                await nextTick()
                confirmButtonRef.value?.focus()
            } else {
                document.removeEventListener('keydown', onKeydown, true)
                previouslyFocused.value?.focus?.()
                previouslyFocused.value = null
            }
        })

        onMounted(() => {
            if (isOpen.value) {
                document.addEventListener('keydown', onKeydown, true)
            }
        })

        onBeforeUnmount(() => {
            document.removeEventListener('keydown', onKeydown, true)
        })

        return {
            confirmButtonRef,
            cancelButtonRef,
            isOpen,
            title,
            text,
            confirmLabel,
            cancelLabel,
            titleId: TITLE_ID,
            descriptionId: DESCRIPTION_ID,
            close,
            confirm,
            onBackdropClick,
            tabTrap,
        }
    },
}
